<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_gift_card_data") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- ********** Start:: slider Data ********** -->
          <div class="col-12">
            <div class="row align-items-center">
              <v-col col="12" sm="12" md="12">
                <UploadsPhotos
                  :urls="imgUrls"
                  multiple
                  @onFileSelect="onFileSelect"
                  @onFileRemove="onFileRemove"
                >
                  {{ $t("PLACEHOLDERS.design") }}
                  <!-- {{ $t("PLACEHOLDERS.extendPhoto") }} -->
                  <span class="text-danger">*</span>
                </UploadsPhotos>
              </v-col>
            </div>
          </div>
          <!-- ********** End::  slider Data ********** -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.card_name_ar')"
            v-model.trim="data.card_name_ar"
            required
          />
          <!-- End:: Name Input -->
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.card_name_en')"
            v-model.trim="data.card_name_en"
            required
          />
          <!-- End:: Name Input -->

          <!-- start min_card_price tel -->

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.min_card_price')"
            v-model="data.min_card_price"
            required
          />
          <!-- end min_card_price tel -->

          <!-- Start:: max_card_price Input -->
          <base-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.max_card_price')"
            v-model.trim="data.max_card_price"
            type="number"
            required
          />
          <!-- End:: max_card_price Input -->

          <!-- <base-select-input
            col="6"
            :optionsList="card_enum"
            :placeholder="$t('PLACEHOLDERS.occasion')"
            v-model="data.card_enum"
            required
          /> -->

          <!-- <v-row>
            <v-col cols="12">
              <base-image-upload-input
                col="12"
                identifier="salon_logo"
                :placeholder="$t('PLACEHOLDERS.salon_logo')"
                @selectImage="selectImageSalon"
                required
              />
            </v-col>
          </v-row> -->

          <!-- Start:: salon_description_ar Input -->
          <!-- <base-input
            col="6"
            rows="4"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.salon_description_ar')"
            v-model.trim="data.salon_description_ar"
            required
          /> -->
          <!-- End:: salon_description_ar Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CreateCity",

  components: {
    UploadsPhotos,
    ChangableMapComponent,
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      EnRegex: /[\u0600-\u06FF]/,

      // Start:: Data Collection To Send
      data: {
        image: {
          path: "",
          file: "",
        },
        salon_image: {
          path: "",
          file: "",
        },
        card_name_ar: null,
        card_name_en: null,
        card_enum: null,
        min_card_price: null,
        max_card_price: null,
        active: 0,
      },

      additionalImages: [],
      imgUrls: [],
      main_sections: [],
      sub_sections: [],
      card_enum: [],

      imageId: [],
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      getCountriesData: "ApiGetsModule/allCountriesData",
    }),
  },

  methods: {
    onFileSelect(files) {
      this.additionalImages = files;
    },

    async onFileRemove(index) {
      this.$delete(this.imgUrls, index);

      const imageId = this.imageId[index];
      try {
        await this.$axios({
          method: "GET",
          url: `delete-file/${imageId}`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.$delete(this.imgUrls, index);
      } catch (error) {
        this.isWaitingRequest = false;
        // Handle error as needed
        this.$message.error(error.response.data.message);
      }
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();

      // if (!this.data.nameAr) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.nameAr"));
      //   return;
      // } else if (!this.data.nameEn) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.nameEn"));
      //   return;
      // } else {
      //   return;
      // }
    },
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectImageSalon(selectedImage) {
      this.data.salon_image = selectedImage;
    },
    // End:: Select Upload Image
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      if (this.data.card_name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.card_name_ar);
      }
      if (this.data.card_name_en) {
        REQUEST_DATA.append("name[en]", this.data.card_name_en);
      }
      if (this.data.min_card_price) {
        REQUEST_DATA.append("min_price", this.data.min_card_price);
      }
      if (this.data.max_card_price) {
        REQUEST_DATA.append("max_price", this.data.max_card_price);
      }

      if (this.additionalImages && this.additionalImages.length > 0) {
        this.additionalImages.forEach((file, index) => {
          REQUEST_DATA.append(`designs[${index}]`, file);
        });
      }
      if (this.data.card_enum) {
        REQUEST_DATA.append("type", this.data.card_enum?.value);
      }

      REQUEST_DATA.append("is_active", +this.data.active);

      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `gift-cards-types/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/gift-cards/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    async getGiftEnum() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `gift-card-enum`,
          params: {
            page: 0,
            limit: 0,
            is_active: 1,
          },
        });
        this.card_enum = res.data.data.map((item, index) => ({
          name: item.name,
          value: item.value,
          id: index,
        }));
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    // start show data
    async showData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `gift-cards-types/${this.$route.params.id}`,
        });

        this.data.card_name_ar = res.data.data?.gift_card_type.name_ar;
        this.data.card_name_en = res.data.data?.gift_card_type.name_en;

        this.imgUrls = res.data.data?.gift_card_type?.designs.map(
          (item) => item.url
        );
        this.imageId = res.data.data?.gift_card_type?.designs.map(
          (item) => item.id
        );

        this.data.card_enum = {
          name: res.data.data?.gift_card_type.type_translated,
          value: res.data.data?.gift_card_type.type,
        };
        this.data.min_card_price = res.data.data?.gift_card_type.min_price;
        this.data.max_card_price = res.data.data?.gift_card_type.max_price;
        this.data.active = +res.data.data?.gift_card_type.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    this.getGiftEnum();
    this.showData();
  },
};
</script>
